import { FunctionComponent } from 'react';
import * as s from './ZeroStep.css';
import 'Styles/pets.css';
import CatIcon from './img/cat.svg';
import Text from '@media-ui/core/src/components/Text';
export const ZeroStep: FunctionComponent = () => {
    return (<section className={s.root}>
      <div className={s.icon}>
        <CatIcon />
      </div>
      <Text className={s.title}>Расскажите о своём питомце</Text>
      <Text className={s.text}>
        Получите доступ к бесплатным консультациям и советам
      </Text>
    </section>);
};
